export default __webpack_public_path__ + "f996927ef4c368cca917a59ae926c890.svg";